import axios from "axios";
import { useSelector } from "react-redux";
import Sidebar from "../../GlobalFiles/Sidebar";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import { API_BASE_URL } from "../../../../../api";
import { Select } from "antd";
import DoctorSelect from "../../../../../Components/Dropdowns/DoctorSelect";
import AgentSelect from "../../../../../Components/Dropdowns/AgentSelect";
import { getSuperGroupName } from "../../../../../utils/getSuperGroupName";

const CommissionPercentage = () => {
  const [loading, setLoading] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [toastId, setToastId] = useState(null);

  const [superGroups, setSuperGroups] = useState([]);
  const [type, setType] = useState("");
  const [doctor, setDoctor] = useState(null);
  const [agent, setAgent] = useState(null);
  const [commonData, setCommonData] = useState(null);
  const [formData, setFormData] = useState({});

  
  useEffect(() => {
    const fetchSuperGroups = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_BASE_URL}/tests/super-groups`);
        setSuperGroups(response.data);
      } catch (_error) {
        console.error("Error fetching super groups:", _error);
        setSuperGroups([]);
      } finally {
        setLoading(false);
      }
    };
    fetchSuperGroups();
  }, []);

  const { data: { user }, } = useSelector((state) => state.auth);

  const isAdmin = user?.userType === "admin";

  const updateCommission = async () => {
    // console.log("Updating commission with data:", formData);
    try {
      setLoading(true);
      const id = type === "doctor" ? doctor : agent;
      const response = await axios.patch(`${API_BASE_URL}/tests/super-groups/comission/${type}/${id}/update`, {
        commissions: formData
      });
      console.log("Updated commission data: ", response.data);
      toast.success("Commission percentages updated successfully!", { toastId });
    } catch (_error) {
      console.error("Error fetching commission data:", _error);
      toast.error("Failed to update commission percentages.", { toastId });
    } finally {
      setLoading(false);
    }
  };

  const fetchComissiondata = async (type, id) => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/tests/super-groups/comission/${type}/${id}`);
      setCommonData(response.data || {});
      setFormData(response.data?.commissions || {});
      console.log("Fetched commission data:", response.data);
    } catch (_error) {
      console.error("Error fetching commission data:", _error);
      setCommonData({});
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => {
    fetchComissiondata(type, type === "doctor" ? doctor : agent);
  };

  const handleDoctorSelect = async (doctorId) => {
    if ( type === "doctor" && doctorId === doctor ) return;
    setDoctor(doctorId);
    fetchComissiondata(type, doctorId);
  };


  const handleAgentSelect = async (agentId) => {
    if ( type === "agent" && agentId === agent ) return;
    setAgent(agentId);
    fetchComissiondata(type, agentId);
  };

  const handleInputChange = (superGroup, val) => {
    const numeric = val === '' ? '' : Number(val);
    const bounded = numeric === '' ? '' : Math.max(0, Math.min(100, numeric));
    setFormData((prev) => ({ ...prev, [superGroup]: bounded }));
  };

  const handleTypeChange = (val) => {
    setType(val);
    setDoctor(null);
    setAgent(null);
    setCommonData(null);
    setFormData({});
  };


  if (!isAdmin) {
    return (
      <div className="flex min-h-screen bg-gray-100">
        <Sidebar />
        <div className="flex-1 p-4 md:p-8 flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h2>
            <p className="text-gray-600">Only managers can access this page.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar onCollapse={setSidebarCollapsed} />
      <div className={`flex-1 p-6 transition-all duration-300 ${sidebarCollapsed ? 'ml-20' : 'ml-0'}`}>
        <div className="max-w-5xl mx-auto mt-6">
          <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
            <div className="flex flex-col gap-6 md:flex-row md:items-start md:justify-between">
              <div className="flex items-start gap-4">
                <div className="p-3 rounded-xl bg-gray-900 text-white shadow-sm">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2v4c0 1.105 1.343 2 3 2s3-.895 3-2v-4c0-1.105-1.343-2-3-2z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v1m0 14v1m8-8h-1M5 12H4m12.364-6.364l-.707.707M7.05 16.95l-.707.707m12.02 0l-.707-.707M7.05 7.05L6.343 6.343" />
                  </svg>
                </div>
                <div>
                  <h1 className="text-2xl font-bold text-gray-900">Commission Percentage</h1>
                  <p className="text-sm text-gray-600">Define doctor and agent commission (%) by SuperGroup with one update.</p>
                  <div className="mt-3 flex flex-wrap items-center gap-2">
                    <span className="rounded-full bg-gray-100 px-3 py-1 text-xs font-semibold text-gray-700">
                      SuperGroups: {superGroups.length}
                    </span>
                    <span className="rounded-full bg-gray-100 px-3 py-1 text-xs font-semibold text-gray-700">
                      {type ? `Mode: ${type}` : "Select a mode"}
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap items-center gap-2">
                <button
                  onClick={handleRefresh}
                  className="px-4 py-2 text-sm font-semibold bg-white border border-gray-200 rounded-lg hover:bg-gray-50"
                  title="Refresh categories"
                >
                  Refresh
                </button>
              </div>
            </div>
          </div>

          <div className="mt-6 rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
            <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
              <div>
                <p className="text-sm font-semibold text-gray-700">Choose commission target</p>
                <p className="text-xs text-gray-500">Pick a type and then select a doctor or agent to load current values.</p>
              </div>
              <Select
                defaultValue={""}
                value={type}
                onChange={handleTypeChange}
                className="w-full md:w-64"
              >
                <Select.Option value="" disabled>-- Select Type --</Select.Option>
                <Select.Option value="doctor">Doctor Commission</Select.Option>
                <Select.Option value="agent">Agent Commission</Select.Option>
              </Select>
            </div>

            {type === "doctor" && (
              <div className="mt-4 flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
                <p className="text-sm font-semibold text-gray-700">Select Doctor</p>
                <DoctorSelect
                  defaultValue={doctor}
                  selectedId={doctor}
                  onSelectID={handleDoctorSelect}
                  className="w-full md:w-64"
                />
              </div>
            )}

            {type === "agent" && (
              <div className="mt-4 flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
                <p className="text-sm font-semibold text-gray-700">Select Agent</p>
                <AgentSelect
                  defaultValue={agent}
                  selectedId={agent}
                  onSelectID={handleAgentSelect}
                  className="w-full md:w-64"
                />
              </div>
            )}
          </div>

          {commonData?.record && (
            <div className="mt-6 rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
              <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
                <h2 className="text-sm font-semibold text-gray-700">Selected {type === "doctor" ? "Doctor" : "Agent"}</h2>
                <span className="text-xs text-gray-500">Loaded commission settings</span>
              </div>
              <div className="mt-3 grid gap-2 text-sm text-gray-700 md:grid-cols-2">
                <p><span className="font-semibold">ID:</span> {type === "doctor" ? (commonData?.record?.docID || "N/A") : (commonData?.record?.agentID || "N/A")}</p>
                <p><span className="font-semibold">Name:</span> {type === "doctor" ? (commonData?.record?.docName || "N/A") : (commonData?.record?.name || "N/A")}</p>
              </div>
            </div>
          )}

          <div className="mt-6 bg-white shadow-sm rounded-2xl border border-gray-200 p-6">
            <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
              <p className="text-sm text-gray-600">Set commission (%) per SuperGroup. Update applies to all categories in the group.</p>
              <span className="text-xs text-gray-500">All values are clamped to 0-100%</span>
            </div>
            { loading ? (
              <div className="py-8 text-center">
                <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-600 mx-auto"></div>
                <div className="mt-3 text-gray-600">Loading categories...</div>
              </div>
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full table-auto border-collapse">
                  <thead>
                    <tr className="bg-gray-50">
                    { superGroups.length > 0 && superGroups.map((sg) => (
                      <th key={sg} className="p-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-600">{getSuperGroupName(sg)}</th>
                    )) }
                    </tr>
                  </thead>
                  <tbody>
                    { (!doctor && !agent) && (
                      <tr><td className="p-4 text-center text-gray-500 font-medium" colSpan={superGroups.length || 1}>Please select a Doctor or Agent above to manage commission percentages.</td></tr>
                    )}

                    { (doctor || agent) && (
                      <tr>
                        { superGroups.map((sg) => {
                          return (
                            <td key={sg} className="p-3 align-top border border-gray-100">
                              <div className="mb-2">
                                <input
                                  type="number"
                                  min="0"
                                  max="100"
                                  onBlur={(e) => {
                                    if (e.target.value === '') {
                                      handleInputChange(sg, 0);
                                    }
                                  }}
                                  value={formData[sg] !== undefined ? formData[sg] : 0}
                                  onChange={(e) => handleInputChange(sg, e.target.value)}
                                  className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:border-gray-400 focus:ring-2 focus:ring-gray-100"
                                  placeholder="e.g., 10"
                                />
                              </div>
                            </td>
                          );
                        }) }
                      </tr>
                    )}
                  </tbody>
                </table>

                <div className="mt-4 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                  <p className="text-xs text-gray-500">Tip: update one group at a time to keep changes readable.</p>
                  <button
                    onClick={updateCommission}
                    disabled={!doctor && !agent}
                    className="px-5 py-2.5 bg-gray-900 text-white rounded-lg font-semibold hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Update Percentage
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommissionPercentage;